var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusProducerHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1517_13823)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.445 16.445A9.23 9.23 0 0 1 11 18.333C4.583 18.333.917 11 .917 11a16.912 16.912 0 0 1 4.638-5.445m3.52-1.668A8.36 8.36 0 0 1 11 3.667C17.416 3.667 21.083 11 21.083 11a16.966 16.966 0 0 1-1.98 2.924m-6.16-.98a2.75 2.75 0 1 1-3.886-3.887M.917.917l20.166 20.166"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1517_13823"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusProducerHidden);
export default __webpack_public_path__ + "static/media/status-producer-hidden.24ea97cdec08fe1f9d54270d4e406403.svg";
export { ForwardRef as ReactComponent };